import React from "react";
import sapDashboard from "../../assets/RPA/sap-dashboard.png";

const SAPAutomation = () => {
  return (
    <section className="relative w-full py-20 px-6 md:px-12 lg:px-24 bg-[#001a05] overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 opacity-40">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#f6e550] blur-[150px] opacity-10 rounded-full translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-[#90d689] blur-[180px] opacity-10 rounded-full -translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="max-w-[1440px] mx-auto grid grid-cols-5 mobile:grid-cols-1 ipadMin:grid-cols-1 gap-16 relative z-10 items-center ">
        {/* Left Column: Vision & Features */}
        <div className="flex flex-col gap-10 laptop:col-span-2 largeScreen:col-span-2 ipadMax:col-span-2">
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3 bg-[#00450d]/50 border border-[#90d689]/20 w-fit px-4 py-2 rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
              >
                <path
                  d="M9.72708 4.08333L9.08542 2.68333L7.68542 2.04167L9.08542 1.4L9.72708 0L10.3687 1.4L11.7688 2.04167L10.3687 2.68333L9.72708 4.08333ZM10.8938 8.16667L10.4271 7.175L9.43542 6.70833L10.4271 6.24167L10.8938 5.25L11.3604 6.24167L12.3521 6.70833L11.3604 7.175L10.8938 8.16667ZM3.31042 11.6667L3.13542 10.2958C3.06736 10.2667 2.99444 10.2278 2.91667 10.1792C2.83889 10.1306 2.77569 10.0819 2.72708 10.0333L1.44375 10.5875L0 8.05L1.09375 7.23333C1.09375 7.15556 1.09375 7.07778 1.09375 7C1.09375 6.92222 1.09375 6.84444 1.09375 6.76667L0 5.95L1.44375 3.4125L2.72708 3.96667C2.77569 3.91806 2.83889 3.86944 2.91667 3.82083C2.99444 3.77222 3.06736 3.73333 3.13542 3.70417L3.31042 2.33333H6.22708L6.40208 3.70417C6.47014 3.73333 6.54306 3.77222 6.62083 3.82083C6.69861 3.86944 6.76181 3.91806 6.81042 3.96667L8.09375 3.4125L9.5375 5.95L8.44375 6.76667C8.44375 6.84444 8.44375 6.92222 8.44375 7C8.44375 7.07778 8.44375 7.15556 8.44375 7.23333L9.5375 8.05L8.09375 10.5875L6.81042 10.0333C6.76181 10.0819 6.69861 10.1306 6.62083 10.1792C6.54306 10.2278 6.47014 10.2667 6.40208 10.2958L6.22708 11.6667H3.31042ZM4.76875 8.75C5.25486 8.75 5.66806 8.57986 6.00833 8.23958C6.34861 7.89931 6.51875 7.48611 6.51875 7C6.51875 6.51389 6.34861 6.10069 6.00833 5.76042C5.66806 5.42014 5.25486 5.25 4.76875 5.25C4.28264 5.25 3.86944 5.42014 3.52917 5.76042C3.18889 6.10069 3.01875 6.51389 3.01875 7C3.01875 7.48611 3.18889 7.89931 3.52917 8.23958C3.86944 8.57986 4.28264 8.75 4.76875 8.75ZM4.33125 10.5H5.20625L5.32292 9.45C5.60486 9.37222 5.84549 9.27257 6.04479 9.15104C6.2441 9.02951 6.44097 8.86667 6.63542 8.6625L7.59792 9.1L8.00625 8.37083L7.16042 7.72917C7.23819 7.50556 7.27708 7.2625 7.27708 7C7.27708 6.7375 7.23819 6.49444 7.16042 6.27083L8.00625 5.62917L7.59792 4.9L6.63542 5.3375C6.44097 5.13333 6.2441 4.97049 6.04479 4.84896C5.84549 4.72743 5.60486 4.62778 5.32292 4.55L5.20625 3.5H4.33125L4.21458 4.55C3.93264 4.62778 3.69201 4.72743 3.49271 4.84896C3.2934 4.97049 3.09653 5.13333 2.90208 5.3375L1.93958 4.9L1.53125 5.62917L2.37708 6.27083C2.29931 6.49444 2.25799 6.7375 2.25312 7C2.24826 7.2625 2.28958 7.50556 2.37708 7.72917L1.53125 8.37083L1.93958 9.1L2.90208 8.6625C3.09653 8.86667 3.2934 9.02951 3.49271 9.15104C3.69201 9.27257 3.93264 9.37222 4.21458 9.45L4.33125 10.5Z"
                  fill="#ACF4A4"
                />
              </svg>
              <span className="text-[#90d689] text-xs font-bold tracking-[2px] uppercase manrope">
                Enterprise Core
              </span>
            </div>

            <h2 className="text-5xl md:text-5xl lg:text-6xl mobile:text-3xl font-extrabold text-white leading-tight manrope">
              SAP <br />
              <span className="text-[#90d689]">Intelligent</span> <br />
              Automation <br />
            </h2>

            <p className="text-[#acf4a4] text-lg max-w-lg leading-relaxed lg:text-xl">
              Transcending traditional RPA with SAP-native agentic intelligence.
              We engineer autonomous systems that manage the entire ERP
              lifecycle with surgical precision.
            </p>
          </div>

          <div className="flex flex-col gap-6">
            {/* Feature 1 */}
            <div className="group bg-white/5 backdrop-blur-md border border-white/10 p-8 rounded-[32px] hover:bg-white/10 transition-all cursor-default shadow-xl">
              <div className="flex items-start gap-6 mobile:flex-col ipadMax:flex-col  ipadMax:gap-3">
                <div className="p-4 mobile:p-2 ipadMax:p-2 bg-[#90d689]/10 rounded-2xl group-hover:scale-110 transition-transform">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#90d689"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-git-compare-arrows"
                  >
                    <circle cx="5" cy="6" r="3" />
                    <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                    <path d="m15 9-3-3 3-3" />
                    <circle cx="19" cy="18" r="3" />
                    <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                    <path d="m9 15 3 3-3 3" />
                  </svg>
                </div>
                <div className="flex flex-col gap-2">
                  <h4 className="text-xl font-bold text-white manrope">
                    Zero-Touch Reconciliations
                  </h4>
                  <p className="text-[#acf4a4]/70 leading-relaxed text-sm">
                    Real-time autonomous matching of complex bank statements
                    with nested ledger entries.
                  </p>
                </div>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="group bg-white/5 backdrop-blur-md border border-white/10 p-8 rounded-[32px] hover:bg-white/10 transition-all cursor-default shadow-xl">
              <div className="flex items-start gap-6 mobile:flex-col ipadMax:flex-col ipadMax:gap-3">
                <div className="p-4 mobile:p-2  ipadMax:p-2 bg-[#f6e550]/10 rounded-2xl group-hover:scale-110 transition-transform">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#f6e550"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-file-search"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <circle cx="11.5" cy="15.5" r="2.5" />
                    <path d="M13.25 17.25 15 19" />
                  </svg>
                </div>
                <div className="flex flex-col gap-2">
                  <h4 className="text-xl font-bold text-white manrope">
                    Purchase Order Intelligence
                  </h4>
                  <p className="text-[#acf4a4]/70 leading-relaxed text-sm">
                    Cognitive vendor validation and multi-tier price variance
                    detection at sub-second speeds.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Results & Interactive Visual */}
        <div className="flex flex-col gap-8 laptop:col-span-3 largeScreen:col-span-3  ipadMax:col-span-3">
          {/* Metrics Tier */}
          <div className="grid grid-cols-2 gap-6 mobile:grid-cols-1 ipadMin:grid-cols-1">
            <div
              className="rounded-[24px] 
  border-t border-r border-b border-white/10 
  border-l-[4px] border-l-white/10 
  bg-white/[0.03] 
  backdrop-blur-[10px] p-8 mobile:p-4 ipadMin:p-4 flex flex-col gap-3 group hover:-translate-y-2 transition-transform duration-300"
            >
              <span className="text-white/30 font-inter text-xs leading-4 uppercase tracking-wider font-semibold">
                Cost Reduction
              </span>
              <div className="flex items-baseline gap-1">
                <span className="text-5xl font-black text-white manrope">
                  85<span className="text-[#ACF4A4]">%</span>
                </span>
              </div>
              <p className="text-[#acf4a4]/60 text-xs leading-relaxed">
                Average operational saving per business unit
              </p>
            </div>

            <div
              className="rounded-[24px] 
  border-t border-r border-b border-white/10 
  border-l-[4px] border-l-white/10 
  bg-white/[0.03] 
  backdrop-blur-[10px]  p-8 mobile:p-4 ipadMin:p-4  flex flex-col gap-3 group hover:-translate-y-2 transition-transform duration-300"
            >
              <span className="text-white/30 font-inter text-xs leading-4 uppercase tracking-wider font-semibold">
                Processing Speed
              </span>
              <div className="flex items-baseline gap-1">
                <span className="text-5xl font-black text-white manrope">
                  10<span className="text-[#F6E550]">X</span>
                </span>
              </div>
              <p className="text-[#acf4a4]/60 text-xs leading-relaxed">
                Faster than manual SAP workflow processing
              </p>
            </div>
          </div>
          <div className="relative group ">
            {/* The outer glow/border effect */}
            <div className="absolute -inset-0.5 bg-gradient-to-r from-[#90d689]/20 to-[#f6e550]/10 rounded-[40px] blur-sm group-hover:blur-md transition-all"></div>

            <div className="relative bg-[#001a05] border border-white/10 rounded-[40px] p-8 overflow-hidden shadow-2xl">
              {/* Header Section */}
              <div className="flex mobile:flex-col mobile:gap-2 mobile:place-items-start  items-center justify-between mb-10">
                <div className="flex  mobile:flex-col mobile:place-items-start gap-5 place-items-center">
                  <div className="flex gap-2">
                    <div className="w-3 h-3 rounded-full bg-[#ff5f57]/80"></div>
                    <div className="w-3 h-3 rounded-full bg-[#febc2e]/80"></div>
                    <div className="w-3 h-3 rounded-full bg-[#28c840]/80"></div>
                  </div>
                  <div className="text-white/30 font-mono text-[12px] leading-4 font-normal">
                    system.log_sap_agent_active
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="flex gap-1">
                    <div className="w-8 h-1 bg-white/10 rounded-full"></div>
                    <div className="w-8 h-1 bg-[#90d689]/40 rounded-full"></div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-10">
                {/* Title and ID Section */}
                <div className="flex items-center mobile:flex-col mobile:gap-2 justify-between">
                  <div className="flex items-center gap-6">
                    <div className="w-16 h-16 bg-[#90d689]/5 border border-[#90d689]/20 rounded-2xl flex items-center justify-center shadow-[0_0_20px_rgba(144,214,137,0.1)]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#90d689"
                        strokeWidth="1.5"
                        className="opacity-80"
                      >
                        <ellipse cx="12" cy="5" rx="9" ry="3" />
                        <path d="M3 5V19A9 3 0 0 0 21 19V5" />
                        <path d="M3 12A9 3 0 0 0 21 12" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-3xl font-semibold text-white tracking-tight">
                        SAP Purchase Requisition
                      </h4>
                      <p className="text-white/30 text-xs tracking-[2px] mt-1 uppercase font-medium">
                        REQ_ID: #88219-X0
                      </p>
                    </div>
                  </div>
                  <div className="px-6 py-2 bg-[#90d689]/10 border border-[#90d689]/30 rounded-full">
                    <span className="text-[#90d689] text-[11px] font-black uppercase tracking-[2px]">
                      Automated
                    </span>
                  </div>
                </div>

                {/* Progress Bars Section */}
                <div className="flex flex-col gap-5">
                  <div className="w-full bg-white/5 h-2.5 rounded-full overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-[#0d3d13] via-[#90d689] to-[#c7f4c1] w-[85%] rounded-full"></div>
                  </div>
                  <div className="w-full bg-white/5 h-2.5 rounded-full overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-[#0d3d13] to-[#90d689] w-[55%] rounded-full opacity-60"></div>
                  </div>
                  <div className="w-2/3 bg-white/5 h-2.5 rounded-full"></div>
                </div>

                {/* Footer Section */}
                <div className="flex items-end justify-between pt-8 border-t border-white/5 mobile:flex-col mobile:gap-2 mobile:place-items-start">
                  <div className="flex -space-x-3">
                    <div className="w-12 h-12 rounded-full bg-[#1a2e1c] border border-white/10 flex items-center justify-center shadow-lg">
                      <div className="w-4 h-2.5 border-2 border-[#90d689] rounded-sm opacity-70"></div>
                    </div>
                    <div className="w-12 h-12 rounded-full bg-[#2a2915] border border-white/10 flex items-center justify-center shadow-lg backdrop-blur-md">
                      <span className="text-[#f6e550] text-[10px] font-bold">
                        AI
                      </span>
                    </div>
                  </div>

                  <div className="text-right">
                    <div className="text-white text-2xl font-bold tracking-tight">
                      99.9% Accuracy
                    </div>
                    <div className="text-white/30 text-[10px] uppercase mt-1 tracking-[2px] font-medium">
                      Validated in 0.4s
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SAPAutomation;
